<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>固件版本</BreadcrumbItem>
        </Breadcrumb>
        <div class="searchBox">
          <div>
            <Button type="primary" icon="plus-round" @click="addFirmware" v-if="authList.indexOf('008002') !== -1">添加</Button>
          </div>
        </div>

        <Table border height="520" ref="firmware_table" :columns="columns" :data="tableData"></Table>
        <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
      </div>
    </div>
    <Modal
      v-model="openSimple"
      title="添加固件版本"
      @on-ok="sureAdd"
      @on-cancel="cancelAdd">
      <p style="margin-bottom: 10px;">
        <span style="display:inline-block;margin-right: 10px;font-size: 14px;width: 60px;text-align: right;"><span style="color: red;">*</span>版本号</span>
        <Input v-model="firmwareNo" style="width: 300px;"/>
      </p>
      <p>
        <span style="display:inline-block;margin-right: 10px;font-size: 14px;width: 60px;text-align: right;vertical-align: top;">备注</span>
        <Input type="textarea" :rows="4" v-model="memo" style="width: 300px;resize: none;" :maxlength=32 />
      </p>
    </Modal>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import {errorHandler} from '../../util/errorHandler'
import {nError, nSuccess} from '../../util/notice'
import {getAuthStr} from '../../util/bus'

export default {
  name: 'firmware-version',
  data () {
    return {
      authList: '',
      total: 0,
      columns: [
        {
          title: '固件版本',
          key: 'firmwareNo',
          width: 240,
          align: 'center'
        }, {
          title: '备注',
          key: 'memo',
          align: 'center'
        }, {
          title: '创建时间',
          key: 'createTime',
          align: 'center'
        }
      ],
      reqbody: {
        deviceNo: '',
        pageSize: 10,
        pageNo: 1
      },
      firmwareNo: '',
      memo: '',
      tableData: [],
      openSimple: false
    }
  },
  created () {
    this.authList = getAuthStr()
    this.getFactorySettingPage()
  },
  methods: {
    getFactorySettingPage () {
      this.$axios.post(`${httpUrl.url}/manage/firmware/getPage`, this.reqbody)
        .then(res => {
          let data = res.data.data
          data.list.map(v => {
            if (v.createTime) {
              v.createTime = v.createTime.slice(0, 19)
            } else {
              v.createTime = '--'
            }
          })
          this.tableData = data.list
          this.total = data.total
        })
        .catch(errorHandler('获取数据失败'))
    },
    addFirmware () {
      this.openSimple = true
    },
    sureAdd () {
      if (!this.firmwareNo) {
        nError('版本号必填')
        return false
      }
      let passFirmware = /^[0-9]\.[0-9]\.[0-9]$/
      let passResult = passFirmware.test(this.firmwareNo)
      if (!passResult) {
        this.firmwareNo = ''
        nError('请输入正确的版本号，如1.0.1')
        return false
      }
      let obj = {}
      obj.firmwareNo = this.firmwareNo
      obj.memo = this.memo
      this.$axios.post(`${httpUrl.url}/manage/firmware/add`, obj)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.firmwareNo = ''
            this.memo = ''
            this.getFactorySettingPage()
          }
        })
        .catch(errorHandler('添加失败'))
    },
    cancelAdd () {
      this.amount = 1
    },
    sercher () {
      this.getFactorySettingPage()
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getFactorySettingPage()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getFactorySettingPage()
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .searchBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .table_page {
    text-align: right;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/factory-allocation/firmware-version.vue